// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./BubbleTabs.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { RadioGroupRoot } from "../_internal_radio_group";

const styles = [
  {
    type: "default",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const BubbleTabsContext = createContext(null);

function BubbleTabs(_props) {
  const defaults = useContext(BubbleTabsContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RadioGroupRoot
      {...props}
      key="segmented-control-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "segmented-control-root",
        scope: "4j6S8Z6pJr",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => props.children}
    </RadioGroupRoot>
  );
}

BubbleTabs.__variants = [];

export default BubbleTabs;
